export const DEFAULT_PAGE_SIZE = 20;

export const PAGE_SIZE_OPTIONS: string[] = ['10', '20', '50', '100'];

export const DATE_TIME_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
	month: 'short',
	day: '2-digit',
	year: 'numeric',
	hour: '2-digit',
	minute: '2-digit',
	hour12: false
} as const;
